<div class="modal-header">
  <div>
    <h4 class="modal-title">
      {{ package?.parcelService?.parcelService }}
    </h4>
    <span 
      class="badge"
      [ngClass]="{
        'text-bg-secondary': !package?.status,
        'text-bg-success': package?.status
      }">
      {{ package?.statusLabel }}
    </span>
  </div>
  <button 
    type="button" 
    class="btn-close" 
    aria-label="Close" 
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  <div class="container-fluid">
    <div class="row">


      @if(package?.parcelService) {
        <div class="col-12 text-secondary">
          <small><b>Paquetería</b></small>
        </div>
        <div class="col-12 mb-3">
          {{ package?.parcelService?.parcelService }}
        </div>
      }

      @if(package?.streetBuilding) {
        <div class="col-6">
          <div class="row">

            <div class="col-12 text-secondary">
              <small><b>Calle</b></small>
            </div>
            <div class="col-12 mb-3">
              {{ package?.streetBuilding?.name }}
            </div>

          </div>
        </div>
      }

      @if(package?.houseFlat) {

        <div class="col-6">
          <div class="row">

            <div class="col-12 text-secondary">
              <small><b>Casa</b></small>
            </div>
            <div class="col-12 mb-3">
              {{ package?.houseFlat?.number }}
            </div>

          </div>
        </div>

      }

      <div class="col-12 text-secondary">
        <small><b>Fotos</b></small>
      </div>
      <div class="col-12 mb-3">
        <div class="row">

          @if(package?.deliverySignature) {
            <div class="col-6 col-md-4 col-lg-3">
              <p-image 
                [src]="package?.deliverySignature!.urlFile"
                [alt]="package?.deliverySignature!.fileId"
                width="100%" 
                [preview]="true" />
            </div>
          }

          @if(package?.idFile) {
            <div class="col-6 col-md-4 col-lg-3">
              <p-image 
                [src]="package?.idFile!.urlFile"
                [alt]="package?.idFile!.fileId"
                width="100%" 
                [preview]="true" />
            </div>
          }

          @for (file of package?.files; track $index) {
            <div class="col-6 col-md-4 col-lg-3">
              <p-image 
                [src]="file?.urlFile"
                [alt]="file.fileId"
                width="100%" 
                [preview]="true" />
            </div>
          }

        </div>
      </div>

      <!-- @if(package?.createdBy) {
        <div class="col-12 text-secondary">
          <small><b>Reportado por</b></small>
        </div>
        <div class="col-12 mb-3">
          {{ package?.createdBy?.fullName }}
        </div>
      } -->

    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="col-12">
    <button
      type="button"
      class="btn btn-success w-100"
      (click)="activeModal.close()">
      OK
    </button>
  </div>
</div>
